import type { ElementType } from 'react';

import { PeriodTypeEnum } from '@/types/enums/period-type.enum';
import type { StatusTaskCheckEnum } from '@/types/enums/status-task-check.enum';
import { t } from '@/utils/lang';
import Chip from '@mui/material/Chip';

interface StatusChipProps {
    status: StatusTaskCheckEnum;
    size?: 'small' | 'medium';
    component?: ElementType;
    showChip?: boolean;
}

const ChipPeriodType = ({
    status,
    size = 'medium',
    component: Component = Chip,
    showChip = true,
}: StatusChipProps) => {
    let label: string;
    let color: 'info' | 'warning' | 'success' | 'error' | 'default';

    const lowerCaseStatus = String(status || '')?.toLowerCase();

    switch (lowerCaseStatus) {
        case PeriodTypeEnum.Week.toLowerCase():
            label = 'Hàng tuần';
            color = 'info';
            break;
        case PeriodTypeEnum.Month.toLowerCase():
            label = 'Hàng tháng';
            color = 'info';
            break;
        case PeriodTypeEnum.Quarter.toLowerCase():
            label = 'Hàng quý';
            color = 'info';
            break;
        case PeriodTypeEnum.Year.toLowerCase():
            label = 'Hàng năm';
            color = 'info';
            break;
        default:
            label = 'Không xác định';
            color = 'default';
            break;
    }

    if (showChip) {
        return (
            <Component
                variant='tonal'
                label={t(label, 'PeriodType')}
                color={color}
                size={size}
            />
        );
    }

    return {
        label: t(label, 'PeriodType'),
        color,
    };
};

export default ChipPeriodType;
